// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_footer.styl
// module id = 191
// module chunks = 0